<template>
  <div>
    <van-loading v-if="!errorMsg" />
    <div class="errorMsg" v-else>{{ errorMsg }}</div>
    <!-- 确认弹框 -->
    <van-dialog
      v-model="confirmVisible"
      :showConfirmButton="false"
      closeable
      class="reset-dialog"
    >
      <div class="txt">权益领取失败请重新进入页面领取</div>
      <van-button
        class="confirm-btn"
        @click="$router.replace('/liaoningHighway/list')"
      >
        确定
      </van-button>
    </van-dialog>
  </div>
</template>

<script>
import { liaoNingLogin, liaoNingPlace } from '@/api/liaoningHighway'
export default {
  data() {
    return {
      pollingTimer: null, // 轮询定时器
      pollingCount: 0, // 轮询计数器
      confirmVisible: false,
      errorMsg: undefined
    }
  },
  created() {
    this.login()
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
    }
  },
  methods: {
    async login() {
      try {
        const param = encodeURIComponent(this.$route.query.param)
        if (!param) {
          this.errorMsg = '请携带必要参数！'
          return
        }
        const { data } = await liaoNingLogin({ param })
        sessionStorage.setItem('liaoningHighwayToken', data)
        this.processOrderAndPolling()
      } catch (error) {
        console.error('登录失败:', error)
        this.errorMsg = error?.data?.message
      }
    },
    // 处理下单及订单状态检查流程
    async processOrderAndPolling() {
      try {
        const { code } = await liaoNingPlace()
        if (code === 0) {
          // 开始检查订单状态
          this.pollingCount = 0
          this.checkOrderStatus()
        }
      } catch (error) {
        console.error('下单失败:', error)
        this.errorMsg = error?.data?.message
      }
    },
    // 轮询检查订单状态（最多5次）
    async checkOrderStatus() {
      try {
        const { data } = await liaoNingPlace()
        // 检查订单状态
        const hasSuccessOrFailed = data.some(
          order => order.orderStatus === 1 || order.orderStatus === 2
        )

        // 如果有成功或失败的订单，跳转到列表页
        if (hasSuccessOrFailed) {
          // this.$toast.success('下单成功！')
          this.$router.replace('/liaoningHighway/list')
          return
        }

        // 如果只有一个订单且状态为0（发放中），显示确认弹框
        if (data.length === 1 && data[0].orderStatus === 2) {
          this.confirmVisible = true
          return
        }

        // 增加轮询计数
        this.pollingCount++

        // 如果还没达到最大轮询次数，继续轮询
        if (this.pollingCount < 5) {
          this.pollingTimer = setTimeout(() => {
            this.checkOrderStatus()
          }, 1000) // 每秒轮询一次
        } else {
          // 达到最大轮询次数，直接跳转
          this.$router.replace('/liaoningHighway/list')
        }
      } catch (error) {
        console.error('检查订单状态失败:', error)
        this.errorMsg = error?.data?.message
      }
    }
  }
}
</script>

<style lang="less" scoped>
.van-loading {
  text-align: center;
  margin-top: 45vh;
}
.errorMsg {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; // 垂直排列并居中
  height: 80vh;
  text-align: center;
}
.reset-dialog {
  width: 315px;
  height: 272px;
  background: url('~@/assets/img/liaoningHighway/tankBg.png');
  background-size: 100% 100%;
  text-align: center;
  .txt {
    font-size: 22px;
    color: #fff;
    padding: 90px 50px 50px;
  }
  .confirm-btn {
    width: 231px;
    height: 60px;
    background: url('~@/assets/img/liaoningHighway/buttonBg.png');
    background-size: 100% 100%;
    font-size: 20px;
    color: #fff;
    padding: 0;
    .van-button__content {
      margin-top: -10px;
    }
  }
}
</style>
